import {Col} from "react-bootstrap";
import {AuditImages, AuditVideos} from "Pages/Audits/AuditMedia";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

export const MediaViewer = ({
    handleDelete,
    item,
    annotationType,
    updateElementImages,
    loadingProgress,
    isVideoCompressed,
    updateElementVideos,
    loadingVideo,
    videoCompressionFeature,
    isViewOnly = true,
}) => {
    return <Col xs={10} md={6}>
        <>
            <AuditImages
                isSmallSizeNoNotes={true}
                rowImages={[...item[`${annotationType}_images`]]}
                mediaWidth={80}
                mediaHeight={60}
                updateElementImages={updateElementImages}
                elementType={annotationType}
                isViewOnly={isViewOnly}
                deleteMedia={handleDelete}
                isShowNotes={false}
                uploadCountLimit={item.max_images_count}
            />
            {loadingVideo && videoCompressionFeature ?
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                    }}
                ><CircularProgress
                        variant="determinate"
                        value={loadingProgress}
                        sx={{color: "#8CFAD0"}}
                    />
                    <p style={{margin: 0}}>
                        {isVideoCompressed ? "Saving" : "We are compressing your video"}....
                    </p>
                </Box> :
                <AuditVideos
                    isSmallSizeNoNotes={true}
                    rowVideos={item[`${annotationType}_videos`]}
                    mediaWidth={80}
                    mediaHeight={60}
                    updateElementVideos={updateElementVideos}
                    elementType={annotationType}
                    isViewOnly={isViewOnly}
                    deleteMedia={handleDelete}
                    deleteMarginWidth={"-30"}
                    isShowNotes={false}
                    uploadCountLimit={item.max_videos_count}
                    maxVideoDuration={item.max_video_duration}
                />
            }
        </>
    </Col>;
};

MediaViewer.propTypes = {
    isViewOnly: PropTypes.bool.isRequired,
    item: PropTypes.shape({
        displayNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        image_annotation_images: PropTypes.arrayOf(PropTypes.string),
        video_annotation_videos: PropTypes.arrayOf(PropTypes.string),
        max_images_count: PropTypes.number,
        max_videos_count: PropTypes.number,
        max_video_duration: PropTypes.number,
    }).isRequired,
    annotationType: PropTypes.string.isRequired,
    handleDelete: PropTypes.func,
    updateElementImages: PropTypes.func,
    loadingProgress: PropTypes.number,
    isVideoCompressed: PropTypes.bool,
    updateElementVideos: PropTypes.func,
    loadingVideo: PropTypes.bool,
    videoCompressionFeature: PropTypes.bool,
};
